import { limitLines } from 'src/styles'
import styled from 'styled-components'

export const PostTitle = styled.h2`
  ${limitLines(1)}
`

PostTitle.displayName = 'PostTitle'

type PostDescriptionProps = {
  limitChars: boolean
}

export const PostDescription = styled.p<PostDescriptionProps>`
  ${({ limitChars }) => (limitChars ? limitLines(2) : '')};
  opacity: 0.8;
`

PostDescription.displayName = 'PostDescription'

export const ViewMore = styled.a`
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

ViewMore.displayName = 'ViewMore'
